module.exports = __webpack_public_path__ + "img/boy2.840a5f3e.jpg";